import { minLength, required, ValidationRule, requiredIf } from 'vuelidate/lib/validators';
import Vue from 'Vue';
//Please note, that the Bootstrap HTML5 Input validation parameters has to match these, to correctly show the validation text
export default {
    newCustomerNumber: {
        required
    },
    updatePorter: {
        firstName: {
            required,
            minLength: minLength(2)
        },
        lastName: {
            required,
            minLength: minLength(2)
        },
        genericFields: {
            Department: {
                required: requiredIf((x: any) => x != null && x.hasOwnProperty("Department")),
            },
            Locker: {
                required: requiredIf((x: any) => x != null && x.hasOwnProperty("Locker")),
            },
            Shelf: {
                required: requiredIf((x: any) => x != null && x.hasOwnProperty("Shelf")),
            },
            LockerShelf:{
                required: requiredIf((x: any) => x != null && x.hasOwnProperty("LockerShelf")),
            },
            Bridge:{
                
            },
            BOBFE: {
            },
            BA4: {
            },
            BA5: {
            },
            FireBrigade: {
            },
            FirstAid: {
            },
            Forklift: {
            },
            EmployeeCode: {
                required: requiredIf((x: any) => x != null && x.hasOwnProperty("EmployeeCode")),
            }
        }
    }
}